export default "__VITE_ASSET__28dbfe0a__"